import * as React from 'react'

function SvgMf(props) {
	return (
		<svg viewBox="0 0 900 600" width="1em" height="1em" {...props}>
			<path fill="#ED2939" d="M0 0h900v600H0z" />
			<path fill="#fff" d="M0 0h600v600H0z" />
			<path fill="#002395" d="M0 0h300v600H0z" />
		</svg>
	)
}

export default SvgMf
